import { getVoucherCompraIndividual, getVoucherCompraIndividualDowload, deleteVoucherCompraIndividualDocumento } from "../services/documentosService";
const dataInicial = {
    vouchers: [],
    idCompra: 0,
    exito: 0
}

const GET_VOUCHER_ALL = "GET_VOUCHER_ALL"
const DELETE_VOUCHER_ID = "DELETE_VOUCHER_ID"
const UPDATE_VOUCHER_ID = "UPDATE_VOUCHER_ID"
const GET_VOUCHER_DOWLOAD = "GET_VOUCHER_DOWLOAD"

export default function voucherIndividualReducer(state = dataInicial, action) {
    switch (action.type) {
        case GET_VOUCHER_ALL:
            return { ...state, idCompra: action.payload.idCompra, vouchers: action.payload.vouchers }
        case DELETE_VOUCHER_ID:
            return { ...state, exito: action.payload.exito }
        case UPDATE_VOUCHER_ID:
            return { ...state, exito: action.payload.exito }
        case GET_VOUCHER_DOWLOAD:
            return { ...state, exito: action.payload.exito }
        default:
            return state;
    }
}
export const obtenerVouchers = ({ idCompra }) => (dispatch) => {
    return getVoucherCompraIndividual({ idCompra }).then(Response => {
        dispatch({
            type: GET_VOUCHER_ALL,
            payload: {
                idCompra,
                vouchers: Response,
            },
        })
        return Response
    }).catch(Error => {
        return Error
    })
}
export const clearVouchers = () => (dispatch) => {
    dispatch({
        type: GET_VOUCHER_ALL,
        payload: {
            idCompra: dataInicial.idCompra,
            vouchers: dataInicial.vouchers,
            exito: dataInicial.exito
        },
    })
}
export const eliminarVoucher = ({ idDocumento }) => (dispatch) => {
    return deleteVoucherCompraIndividualDocumento({ idDocumento }).then(Response => {
        dispatch({
            type: DELETE_VOUCHER_ID,
            payload: {
                exito: 1
            },
        })
        return Response
    }).catch(Error => {
        return Error
    })
}
export const dowloadVoucherAction = ({ idDocumento }) => (dispatch) => {
    return getVoucherCompraIndividualDowload({ idDocumento }).then(Response => {
        dispatch({
            type: GET_VOUCHER_DOWLOAD,
            payload: {
                exito: 1
            },
        })
        return Response
    }).catch(Error => {
        return Error
    })
}